export const formatNotificationActorName = (
  actor: { firstName: string | null; lastName: string | null } | null
): string => {
  if (!actor) {
    return ''
  }
  return [actor.firstName, actor.lastName].filter(Boolean).join(' ')
}
